<template>
  <el-dialog
    :visible.sync="showEdit"
    width="70%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="发布文章"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="within-school-edit"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules" v-loading="loading">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item class="mes-input" label="请输入文章标题" inline-message="true" style="margin-top: -20px" prop="title">
            <el-input size="small" v-model="form.title" type="text" :rows="1" :maxlength="50" autosize placeholder="请输入标题(建议50字以内)" show-word-limit clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="请设置文章封面" style="margin-top: 5px">
            <el-radio-group v-model="thumbType" size="small" style="margin-top: -20px" @change="handleChangeCoverType" class="d2-mb">
              <el-radio-button label="无封面"></el-radio-button>
              <el-radio-button label="图片"></el-radio-button>
              <el-radio-button label="短视频"></el-radio-button>

            </el-radio-group>
            <love-element-upload
              :list-type="uploadOption.listType"
              :drag="uploadOption.drag"
              :allow-type="uploadOption.allowType"
              :allow-size="uploadOption.allowSize"
              :disabled="uploadOption.disabled"
              :limit="uploadOption.limit"
              :multiple="uploadOption.multiple"
              :love-path="uploadOption.lovePath"
              :file-list="uploadOption.fileList"
              :accept="uploadOption.accept"
              :show-file-list="uploadOption.showFileList"
              @preview="onPreview"
              @remove="onRemove"
              @success="onSuccess" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item prop="content">
        <d2-quill v-model="form.content" @text-change="textChangeHandler" @selection-change="selectionChangeHandler" @editor-change="editorChangeHandler" />
      </el-form-item>
      <el-row>
        <el-col :span="7">
          <el-form-item label="请选择文章标签"  class="within-school-tags">
            <div style="display: flex;margin-top: -10px">
              <el-tag @close="handleTagClose(x)" type="info" :key="x.value" closable size="mini" style="margin-right: 10px" v-for="x in checkedTags">
                #{{x.label}}
              </el-tag>
              <el-select @change="tagChange" v-model="checked" v-show="addNewTags" style="width: 100px" size="mini">
                <el-option v-for="tag in tagOption" :key="tag.value" :label="tag.label" :value="tag"></el-option>
              </el-select>
              <el-button @click="addNewTags=true" v-show="!addNewTags&&checkedTags.length<3" size="mini" type="test">+tag</el-button>
            </div>
<!--            <el-checkbox-group v-model="checkedTagList" :min="1" :max="3">-->
<!--              <el-checkbox @change="tagChange" v-for="tag in tagOption"  :label="tag.value" :key="tag.value">-->
<!--                {{tag.label}}-->
<!--              </el-checkbox>-->
<!--            </el-checkbox-group>-->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      正文字数统计:{{words}}
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">发布</axj-button>
    </div>
  </el-dialog>
</template>

<script>

const defaultForm = {
  status: 0,
  title: '',
  content: '',
  description: '',
  user_id: undefined,
  user_name: '',
  user_avatar: '',
  is_comment: 1,
  thumb1: '',
  thumb2: '',
  thumb3: '',
  thumb_sum: 0,
  video_url: '',
  cover_type: 0,
  school_id: undefined,
  source: '',
  source_directory: ''
}
export default {
  name: "within-school-edit",
  data(){
    return {
      checked:{},
      checkedTags:[],
      addNewTags:false,
      showEdit:false,
      // 记录文章唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // 封面类型
      thumbType: '无封面',
      // tag option
      tagOption: [],
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "text",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: true,
        limit: 3,
        lovePath:{
          module: "information/collegeinter",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        fileList: [],
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      },
      // fileList
      fileList: {
        image: [],
        video: []
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        title: [
          { required: true, message: '文章标题不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: '文章正文不能为空', trigger: 'change' }
        ],
        // main_tag_id: [
        //   { required: true, message: '请选择对应的文章标签', trigger: 'change' }
        // ],
        source: [
          { required: true, message: '请设置文章来源', trigger: 'change' }
        ],
      },
    }
  },
  props: {
    show:{
      type:Boolean,
      default:false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    withInId:{
      type:Number,
      default:undefined
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  },
  computed: {
    words: function() {
      var length = this.form.content.replace(/<[^>]+>/g, "").length
      this.form.description = this.form.content.replace(/<[^>]+>/g, "").slice(0, 100)
      return length
    }

  },
  methods:{
    tagChange(v){
      for(let x=0;x<this.tagOption.length;x++){
        if(this.tagOption[x].value===v.value){
          this.tagOption.splice(x,1)
        }
      }
      this.checkedTags.push(v)
      this.addNewTags=false
      this.checked=undefined
    },
    handleTagClose(v){
      for(let x=0;x<this.checkedTags.length;x++){
        if(this.checkedTags[x].value===v.value){
          this.checkedTags.splice(x,1)
          this.tagOption.push(v)
        }
      }
    },
    handleClose(){
      this.fileList={
        image: [],
        video: [],
        remove: []
      }
      this.thumbType='无封面'
      this.uploadOption={
        listType: "text",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: true,
        limit: 9,
        lovePath:{
          module: "extra/showclub",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        fileList: [],
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      }
      this.checkedTags=[]
      this.form=Object.assign({}, defaultForm)
      this.$emit("close")
    },
    handleOpen(){
      // 初始化一些公用数据
      this.initData()
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      let user=this.$store.getters.getUser
      this.uploadOption.lovePath.source_directory = user.uid + '_' + Date.parse(new Date()) / 1000
      this.checkedTags=[]
      // 判断编辑状态
      if (!this.isCreate) {
        // 编辑文章，使用route中的id获取form
        // const id = this.$route.params && this.$route.params.id
        // // data 中的 id，记录待使用
        // this.id = parseInt(id)
        // 获取文章数据
        this.handleGetArticleData(this.withInId)
      } else {
        // 发布文章 form 为 default form
        this.form = Object.assign({}, defaultForm)
        this.form.school_id = user.schoolId
        //this.form.source = this.info.School.name
      }
    },
    initData() {
      this.$api.axjInformationApi.withinSchool.listWithinSchoolTags()
        .then(res=> {
          this.tagOption = res.data.lists.map(item => {
            return { value: item.id, label: item.name };
          });
        })
    },
    handleGetArticleData(id) {
      this.loading = true
      this.$api.axjInformationApi.withinSchool.getWithinSchool(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          this.form = Object.assign({},this.defaultForm, data)
          let tags=this.form.Tags
          tags.map(i=>{

            this.checkedTags.push({
              label:i.Tag.name,
              value:i.Tag.id
            })
            for(let x=0;x<this.tagOption.length;x++){
              if(this.tagOption[x].value===i.Tag.id){
                this.tagOption.splice(x,1)
              }
            }
          })
          // 去掉form中的多余属性
          this.$delete(this.form,'create_time')
          this.$delete(this.form,'update_time')
          this.$delete(this.form,'School')
          this.$delete(this.form,'MainTag')
          this.$delete(this.form,'Count')
          this.$delete(this.form,'User')
          // 若数据库中已经存放了该文章的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          // 获取封面信息
          var thumbs = []
          data.thumb1 != '' ? thumbs.push(data.thumb1) : 'NULL'
          data.thumb2 != '' ? thumbs.push(data.thumb2) : 'NULL'
          data.thumb3 != '' ? thumbs.push(data.thumb3) : 'NULL'
          this.fileList.image = thumbs.map(item => {
            var thumb = {
              name: '封面',
              url: item
            }
            if (!(item.indexOf('http') >= 0)) {
              thumb.url = this.$store.getters.getResourcePrefix.url + item
            }
            return thumb
          })
          // 判断是否有视频
          if(data.video_url) {
            const regx = /([^/]+)$/
            const videoname = data.video_url.match(regx)
            // 是否有前缀
            let video = {
              name: videoname[1],
              url: data.video_url.indexOf('http')?data.video_url:this.$store.getters.getResourcePrefix.url + data.video_url,
              type: "video",
              status: "success"
            }
            this.fileList.video[0] = video
          }
          // 封面类型
          if (data.cover_type == 0 &&
            data.thumb1 == '' &&
            data.thumb2 == '' &&
            data.thumb3 == '') {
            // 无封面状态
            this.thumbType = '无封面'
          } else if (data.cover_type == 0 &&
            (data.thumb1 != '' ||
              data.thumb2 != '' ||
              data.thumb3 != '')) {
            this.thumbType = '图片'
            this.uploadOption.fileList = this.fileList.image
            this.handleChangeCoverType("图片")
          } else {
            this.thumbType = '短视频'
            this.uploadOption.fileList = this.fileList.video
            this.handleChangeCoverType("短视频")
          }
          // 调用一次切换封面状态
          this.handleChangeCoverType(this.thumbType)
          this.loading = false
        })
        .catch(err=> {
          this.$notify.error({
            message: err
          })
        })
    },
    textChangeHandler(delta, oldDelta, source) {
      // console.group('QuillEditor textChangeHandler')
      // console.log(delta, oldDelta, source)
      // console.groupEnd()
    },
    selectionChangeHandler(range, oldRange, source) {
      // console.group('QuillEditor selectionChangeHandler')
      // console.log(range, oldRange, source)
      // console.groupEnd()
    },
    editorChangeHandler(eventName, ...args) {
      // console.group('QuillEditor editorChangeHandler')
      // console.log(eventName, args)
      // console.groupEnd()
    },
    onChangeSchool(val) {
      if(val) {
        console.log("true", val)
        this.form.school_id = val.value
        this.form.source = val.label
      } else {
        this.form.school_id = null
        this.form.source = ''
      }
    },
    onClearSelectSchool() {
      this.form.school_id = this.info.School.id
      this.form.source = this.info.School.name
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemove(file, fileList) {
      if(this.thumbType==='图片') {
        this.fileList.image = fileList.map(item => {
          if (typeof(item.response) != 'undefined') {
            return {
              uid: item.uid,
              name: item.response.old_name,
              url: item.response.url,
              status: item.status
            }
          }
          return item
        })
      } else {
        this.fileList.video = fileList.map(item => {
          if (typeof(item.response) != 'undefined') {
            return {
              uid: item.uid,
              name: item.response.old_name,
              url: item.response.url,
              status: item.status
            }
          }
          return item
        })
      }
      console.log(file)
      console.log(fileList)
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      // 若上传的文件为 MP4
      if(response.type==='video/mp4') {
        this.form.video_url = response.url
        this.fileList.video[this.fileList.video.length] = file
      } else {
        this.fileList.image[this.fileList.image.length] = file
        // console.log("else")
      }
      console.log(response)
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if(valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为文章的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory


          this.form.Tags=this.checkedTags.map((item)=>{
            return{TagID:item.value}
          })
          // 设置文章封面
          if(this.thumbType==='图片' && this.fileList.image.length) {
            this.form.thumb1 = this.fileList.image[0]?this.fileList.image[0].url.slice(this.$store.getters.getResourcePrefix.url.length):''
            this.form.thumb2 = this.fileList.image[1]?this.fileList.image[1].url.slice(this.$store.getters.getResourcePrefix.url.length):''
            this.form.thumb3 = this.fileList.image[2]?this.fileList.image[2].url.slice(this.$store.getters.getResourcePrefix.url.length):''
            this.form.thumb_sum = this.fileList.image.length
          } else if(this.thumbType==='短视频') {
            this.form.video_url = this.fileList.video[0]?this.fileList.video[0].url.slice(this.$store.getters.getResourcePrefix.url.length):''
          } else {
            // 无封面
            this.form.thumb1 = ''
            this.form.thumb2 = ''
            this.form.thumb3 = ''
            this.form.video_url = ''
            this.form.thumb_sum = 0
          }
          // 创建文章时
          if(this.isCreate) {
            this.form.user_id = this.$store.getters.getUser.infoUserUid
            this.form.user_name = this.$store.getters.getUser.uname
            this.form.user_avatar = this.$store.getters.getUser.avatar
            // this.form.user_id = this.info.id
            // this.form.user_name = this.info.nickname
            // this.form.user_avatar = this.info.avatar
            await this.handleCreateArticle(this.form)
            this.$nextTick(()=> {
              this.$emit("created")
            })
          } else {
            this.$api.axjInformationApi.withinSchool.deleteTagsRelation({
              where:JSON.stringify({
                article_id:this.withInId
              })
            })
            await this.handleUpdateArticle(this.form)
            await this.handleUpdateArticleStatus(this.form)
            this.$emit("updated")
          }
        }
      })
      console.log(this.form)
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateArticle(form) {
      return new Promise((resolve, reject)=> {
        this.loading = true
        this.$api.axjInformationApi.withinSchool.createWithinSchool(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '发布成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '发布失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleUpdateArticle(form) {
      return new Promise((resolve, reject)=> {
        // 修改文章内容
        this.loading = true
        this.$api.axjInformationApi.withinSchool.updateWithinSchool(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateArticleStatus(form) {
      return new Promise((resolve, reject)=> {
        // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
        this.$api.axjInformationApi.withinSchool.updateWithinSchool({
          id: form.id,
          where: JSON.stringify({
            thumb_sum: form.thumb_sum,
            cover_type: form.cover_type,
            school_id: form.school_id,
            status: form.status,
            is_comment: form.is_comment,
            main_tag_id: form.main_tag_id,
            thumb1: form.thumb1,
            thumb2: form.thumb2,
            thumb3: form.thumb3,
            video_url: form.video_url
          })
        })
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '编辑成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '编辑失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleChangeCoverType(type) {
      this.uploadOption.showFileList = false
      if (type == '无封面') {
        this.uploadOption.listType = "text"
        this.uploadOption.allowType = ["image/jpg", "image/jpeg", "image/png"]
        this.uploadOption.drag = false
        this.uploadOption.disabled = true
        this.uploadOption.limit = 3
        this.uploadOption.fileList = [] // 置空
        this.uploadOption.allowSize = 3
        this.uploadOption.accept = 'image/*'
        this.uploadOption.multiple = false
        this.form.cover_type = 0
      } else if (type == '图片') {
        this.uploadOption.listType = "picture-card"
        this.uploadOption.allowType = ["image/jpg", "image/jpeg", "image/png"]
        this.uploadOption.drag = false
        this.uploadOption.disabled = false
        this.uploadOption.limit = 3
        this.uploadOption.fileList = this.fileList.image
        this.uploadOption.allowSize = 3
        this.uploadOption.accept = 'image/*'
        this.uploadOption.multiple = true
        this.form.cover_type = 0
      } else {
        this.uploadOption.listType = "text"
        this.uploadOption.allowType = ["video/mp4"]
        this.uploadOption.drag = true
        this.uploadOption.disabled = false
        this.uploadOption.limit = 1
        this.uploadOption.fileList = this.fileList.video
        this.uploadOption.allowSize = 10
        this.uploadOption.accept = '.mp4'
        this.uploadOption.multiple = false
        this.form.cover_type = 1
      }
      this.uploadOption.showFileList = true
    },
  }
}
</script>

<style slot-scope lang="scss">
.within-school-edit .el-form-item{
  margin-bottom: 10px;
}
.within-school-edit{

  .within-school-tags{
    .el-form-item__content{
      line-height: 10px;
    }
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFF;
    background-color: #41555d;
    border-color: #41555d;
    -webkit-box-shadow: -1px 0 0 0 #41555d;
    box-shadow: -1px 0 0 0 #41555d;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner:hover{
    color: #FFF;
  }
  .el-tag--mini{
    height: 30px;
    padding: 0 5px;
    line-height: 30px;
  }
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;
  }
  .el-upload-list--picture-card{
    .el-upload-list__item,is-success{
      height: 120px;
      width: 120px;
    }
  }
  .el-upload--picture-card{
    width: 120px;
    height: 120px;
    line-height: 125px;
  }
  .el-upload-list__item-thumbnail{
    height: 120px;
    width: 120px;
  }
  .el-upload-list__item-actions{
    width: 120px;
    height: 120px;

  }
  .el-upload-dragger{
    width: 240px;
    line-height: 0px;
    height: 160px;
    .el-icon-upload{
      width: 45px;
      height: 45px;
      margin: 30px 0 28px -20px;
    }
  }

  .dialog-footer{
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-within-school/action/within-school-edit.vue